<template>
    <v-row no-gutters class="mb-1">
        <v-col cols="12" md="4" class="pe-1">
            <v-autocomplete
                label="Item"
                dense
                v-model="line.item_id"
                :items="items"
                :rules="[isRequired]"
                :search-input="itemQuery"
                @update:search-input="itemSearch"
                item-text="display_name"
                item-value="id"
                outlined
                hide-details>
            </v-autocomplete>
        </v-col>
        <v-col cols="12" md="1" class="pe-1">
            <v-text-field
                label="Quantity"
                v-model="line.quantity"
                :rules="[isRequired, isNumeric]"
                dense
                outlined
                hide-details>
            </v-text-field>
        </v-col>
        <v-col cols="12" md="1" class="pe-1">
            <v-autocomplete
                label="Unit"
                :items="measureUnits"
                item-text="abbreviation"
                :rules="[isRequired]"
                v-model="line.measure_unit_id"
                item-value="id"
                dense
                outlined
                hide-details>
            </v-autocomplete>
        </v-col>
        <v-col cols="12" md="6" class="pe-1">
            <v-row no-gutters justify="center" align="center">
                <v-col cols="12" md="11">
                    <v-text-field
                        label="Description"
                        dense
                        v-model="line.description"
                        :rules="[isRequired]"
                        outlined
                        hide-details>
                    </v-text-field>
                </v-col>
                <v-col cols="12" md="1" class="text-center" >
                    <v-btn 
                        icon
                        @click="deleteLine"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { isRequired, isNumeric } from './../../utils/validations';
import { mapActions, mapGetters } from 'vuex';
export default {
    name: "PurchaseRequisitionFormLine",
    props: {
        value: Object
    },
    data() {
        return {
            line : { ...this.value},
            itemQuery: ''
        }
    },
    computed:{
        ...mapGetters({
            items: "purchase/item/list",
        }),
        selectedItem() {
            return this.items.find(item => item.id == this.line.item_id)
        },
        measureUnits() {
            return this.selectedItem && this.selectedItem.measure_units ? this.selectedItem.measure_units : [];
        }
    },
    methods: {
        isRequired, isNumeric,
        ...mapActions({
            itemSearch: "purchase/item/search"
        }),
        deleteLine() {
            this.$emit("delete:line") 
        }
    },
    watch: {
        line: {
            deep: true,
            handler() {
                this.$emit("input", this.line)
            }
        }
    },
}
</script>

<style>

</style>